import { render, staticRenderFns } from "./projects_list_item.vue.js?vue&type=template&id=17bfca1e!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./projects_list_item.vue?vue&type=template&id=17bfca1e"
import script from "./projects_list_item.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./projects_list_item.vue?vue&type=script&lang=js"
export * from "./projects_list_item.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./projects_list_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17bfca1e')) {
      api.createRecord('17bfca1e', component.options)
    } else {
      api.reload('17bfca1e', component.options)
    }
    module.hot.accept("./projects_list_item.vue.js?vue&type=template&id=17bfca1e!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./projects_list_item.vue?vue&type=template&id=17bfca1e", function () {
      api.rerender('17bfca1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/projects_list/projects_list_item.vue"
export default component.exports